var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _circle, _circle2, _circle3, _ellipse2, _circle4, _circle5, _circle6, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 30,
    fill: "#FFC2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.646 66.976C134.118 83.5007 125.961 102.144 109.429 108.62C92.8967 115.095 74.2476 106.95 67.7753 90.4253C61.3031 73.9005 69.4598 55.256 85.9919 48.7809C102.524 42.306 121.174 50.4513 127.646 66.976Z",
    fill: "white",
    stroke: "#752145",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.386 91.8294C191.299 111.6 169.321 121.772 149.324 114.604C129.326 107.436 118.815 85.6188 125.902 65.8477C132.989 46.0766 154.967 35.9046 174.964 43.0726C194.962 50.2407 205.473 72.0582 198.386 91.8294Z",
    fill: "white",
    stroke: "#752145",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132 157.5C114.8 163.5 93.1667 150.667 84.5 143.5C82.1 187.5 96.5 208.5 104 213.5L107 211.5L117.5 193C112.7 177 125.167 162.667 132 157.5Z",
    fill: "#AC4B76",
    stroke: "#752145"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 159.5C123.167 165 113.3 179.3 116.5 192.5",
    stroke: "#752145",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 193.5C105.5 188.7 98.5 197.167 96 202C100 212.8 111.667 214 117.5 214.5L140 198.5C134.4 188.1 122.667 190.833 117.5 193.5Z",
    fill: "#F197BA",
    stroke: "#752145"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 201C100 195.333 112 186.8 124 198",
    stroke: "#752145",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.043 205.598L113.419 216.056L98.5911 208.481L99.3918 197.442L120.043 205.598Z",
    fill: "#FFFCFE",
    stroke: "#3EC6F9",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 193.5C122.833 190.833 136.8 189.1 140 199.5",
    stroke: "#752145",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102,
    cy: 86.75,
    rx: 9,
    ry: 8.79545,
    fill: "#3EC6F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102.818,
    cy: 87.3636,
    r: 4.5,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.1363,
    cy: 83.6818,
    r: 2.86364,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 90.4318,
    r: 2.25,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.17,
    cy: 85.8484,
    rx: 14.1704,
    ry: 13.8484,
    fill: "#3EC6F9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.459,
    cy: 86.8146,
    r: 7.08522,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.662,
    cy: 81.0176,
    r: 4.50878,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.916,
    cy: 91.6454,
    r: 3.54261,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84 155.5C85 174.5 86.2999 216.4 117.5 216L146 195.5C146.833 195.167 148.5 195.6 148.5 200V209L158.5 207",
    stroke: "#752145",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 145.5L78.5 137L91 148L87.5 158.5L69.5 145.5Z",
    fill: "#FFFCFE",
    stroke: "#3EC6F9",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.521 168.946L136.773 156.589L153.231 154.056L159.04 163.477L137.521 168.946Z",
    fill: "#FFFCFE",
    stroke: "#3EC6F9",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.591 146.073L181.64 136.584L193.363 124.759L203.637 128.877L189.591 146.073Z",
    fill: "#FFFCFE",
    stroke: "#3EC6F9",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114.5C61 104.5 69.5 107 73 109.5L71 111C65.4 107.8 57.8333 111.833 55 114.5Z",
    fill: "#752145"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108.5C70 130.333 93.7 171.9 154.5 153.5C168.5 148.833 198.9 130.4 208.5 94",
    stroke: "#752145",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4781 50.5C73.6781 34.9 93.8333 30 107.5 28L110.978 41.5C92.5 35.5 75.5 43.5 68.4781 50.5Z",
    fill: "#752145"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M193 49C186.5 33.5 166 26 149 26L147.5 38C154.5 34 179 33.8448 193 49Z",
    fill: "#752145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkface);
export default __webpack_public_path__ + "static/media/pinkface.33a8633d7f216de8feb105371bfe3ff9.svg";
export { ForwardRef as ReactComponent };